import { createContext, useContext } from 'react';

export interface StaticRouterContext {
  url?: string;
  statusCode?: number;
}

const StaticContext = createContext<StaticRouterContext>({});

const StaticProvider = ({ children, value }) => (
  <StaticContext.Provider value={value}>{children}</StaticContext.Provider>
);

const useStaticContext = () => useContext(StaticContext);

export { StaticProvider, useStaticContext };
